"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitTransaction_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SplitTransaction_Factory = /** @class */ (function () {
    function SplitTransaction_Factory() {
    }
    SplitTransaction_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ParentTransactionId: model.ParentTransactionId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SplitTransactionId: model.SplitTransactionId,
        };
        return result;
    };
    SplitTransaction_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ParentTransactionId: model.ParentTransactionId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SplitTransactionId: model.SplitTransactionId,
        };
        return result;
    };
    return SplitTransaction_Factory;
}());
exports.SplitTransaction_Factory = SplitTransaction_Factory;
